/* eslint-disable react/prop-types */
import React from 'react';
import {
    FormHeader as OriginalFormHeader,
    FormLabel,
    FormOptionalLabel,
    FormSubtitle,
    FormTooltip,
} from '@fiverr-private/forms';

const FormHeader = ({ label, subtitle, tooltip, isOptional }) => (
    <OriginalFormHeader>
        {label && <FormLabel>{label}</FormLabel>}
        {isOptional && <FormOptionalLabel />}
        {tooltip && <FormTooltip content={tooltip} />}
        {subtitle && <FormSubtitle>{subtitle}</FormSubtitle>}
    </OriginalFormHeader>
);

export default FormHeader;
